function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}

function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [],
      _n = !0,
      _d = !1,
      _e = void 0;

  try {
    for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0) {
      ;
    }
  } catch (err) {
    _d = !0, _e = err;
  } finally {
    try {
      _n || null == _i["return"] || _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) {
    descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}

function _possibleConstructorReturn(self, call) {
  return call && ("object" === _typeof(call) || "function" == typeof call) ? call : _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}

function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function (o, p) {
    return o.__proto__ = p, o;
  }, _setPrototypeOf(o, p);
}

import WebMercatorViewport from "viewport-mercator-project";
import assert from "../assert";
import TransitionInterpolator from "./transition-interpolator";
import { isValid, lerp, getEndValueByShortestPath } from "./transition-utils";

var VIEWPORT_TRANSITION_PROPS = ["longitude", "latitude", "zoom", "bearing", "pitch"],
    LinearInterpolator = function (_TransitionInterpolat) {
  function LinearInterpolator() {
    var _this,
        opts = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};

    return _classCallCheck(this, LinearInterpolator), _this = _possibleConstructorReturn(this, (LinearInterpolator.__proto__ || Object.getPrototypeOf(LinearInterpolator)).call(this)), Array.isArray(opts) && (opts = {
      transitionProps: opts
    }), _this.propNames = opts.transitionProps || VIEWPORT_TRANSITION_PROPS, _this.around = opts.around, _this;
  }

  return _inherits(LinearInterpolator, _TransitionInterpolat), _createClass(LinearInterpolator, [{
    key: "initializeProps",
    value: function initializeProps(startProps, endProps) {
      var startViewportProps = {},
          endViewportProps = {};
      this.around && Object.assign(endViewportProps, endProps, {
        around: this.around,
        aroundLngLat: new WebMercatorViewport(endProps).unproject(this.around)
      });

      var _iteratorNormalCompletion = !0,
          _didIteratorError = !1,
          _iteratorError = void 0;

      try {
        for (var _step, _iterator = this.propNames[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
          var key = _step.value,
              startValue = startProps[key],
              endValue = endProps[key];
          assert(isValid(startValue) && isValid(endValue), "".concat(key, " must be supplied for transition")), startViewportProps[key] = startValue, endViewportProps[key] = getEndValueByShortestPath(key, startValue, endValue);
        }
      } catch (err) {
        _didIteratorError = !0, _iteratorError = err;
      } finally {
        try {
          _iteratorNormalCompletion || null == _iterator.return || _iterator.return();
        } finally {
          if (_didIteratorError) throw _iteratorError;
        }
      }

      return {
        start: startViewportProps,
        end: endViewportProps
      };
    }
  }, {
    key: "interpolateProps",
    value: function interpolateProps(startProps, endProps, t) {
      var viewport = {},
          _iteratorNormalCompletion2 = !0,
          _didIteratorError2 = !1,
          _iteratorError2 = void 0;

      try {
        for (var _step2, key, _iterator2 = this.propNames[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = !0) {
          key = _step2.value, viewport[key] = lerp(startProps[key], endProps[key], t);
        }
      } catch (err) {
        _didIteratorError2 = !0, _iteratorError2 = err;
      } finally {
        try {
          _iteratorNormalCompletion2 || null == _iterator2.return || _iterator2.return();
        } finally {
          if (_didIteratorError2) throw _iteratorError2;
        }
      }

      if (endProps.around) {
        var _getMapCenterByLngLat = new WebMercatorViewport(Object.assign({}, endProps, viewport)).getMapCenterByLngLatPosition({
          lngLat: endProps.aroundLngLat,
          pos: endProps.around
        }),
            _getMapCenterByLngLat2 = _slicedToArray(_getMapCenterByLngLat, 2),
            longitude = _getMapCenterByLngLat2[0],
            latitude = _getMapCenterByLngLat2[1];

        viewport.longitude = longitude, viewport.latitude = latitude;
      }

      return viewport;
    }
  }]), LinearInterpolator;
}(TransitionInterpolator);

export { LinearInterpolator as default };